import { TextItemSchema } from 'cms/schemaTypes/staticPages/objects/textItem'

import CustomPortableText from 'lib/sanity/richText/CustomPortableText'

import { SectionContainer } from '../landings/styles'

import styles from './QualityGuaranteeContentSection.module.scss'

interface QualityGuaranteeContentSectionProps {
  howItWorksSection: TextItemSchema
  complaintsSection: TextItemSchema
}

const QualityGuaranteeContentSection = ({
  howItWorksSection,
  complaintsSection
}: QualityGuaranteeContentSectionProps) => {
  return (
    <>
      <SectionContainer className={styles.section}>
        <CustomPortableText value={howItWorksSection.textField || []} />
      </SectionContainer>
      <SectionContainer className={styles.section}>
        <CustomPortableText value={complaintsSection.textField || []} />
      </SectionContainer>
    </>
  )
}

export default QualityGuaranteeContentSection
